// extracted by mini-css-extract-plugin
module.exports = {"container":"SystemProfile_container__1K-P7","header-container":"SystemProfile_header-container__3Ce9O","col-12":"SystemProfile_col-12__O2f87","col-6":"SystemProfile_col-6__TFjW3"};